<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card">
            <el-page-header content="用户充值" :icon="null" title="充值管理">
                <template #extra>
                    <el-button type="primary" @click="searchFun(1)">查询</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                </template>
                <el-form :model="search" label-width="100px" class="demo-ruleForm">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="手机号:" prop="phone">
                                <el-input v-model="search.phone" type="number" placeholder="请输入手机号"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="是否有余额:" prop="isZeroBalance">
                                <el-select v-model="search.isZeroBalance" class="m-2" clearable placeholder="请选择是否有余额"
                                    style="width: 100%" @change="searchFun(1)">
                                    <el-option v-for="item in state.options" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="用户名:" prop="userName">
                                <el-input v-model="search.userName" placeholder="请输入用户名" @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%" height="calc(100vh - 295px)" row-key="id"
                v-loading="state.tableLoading" :row-class-name="tableRowClassName" @row-click="rowClick"
                highlight-current-row>
                <el-table-column prop="userName" label="用户名称" min-width="200px" />
                <el-table-column prop="phone" label="手机号" min-width="130px" />
                <el-table-column prop="curAmt" label="当前余额" min-width="150px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row?.curAmt / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="userNature " label="用户标签" min-width="120px">
                    <template #default="scope">
                        {{ filterUserNature(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column prop="memberType" label="会员类型" min-width="100px" />
                <el-table-column prop="type" label="用户类型" min-width="100px">
                    <template #default="scope">
                        {{ statusMap[scope.row.type] }}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="140px">
                    <template #default="scope">
                        <el-button type="primary" @click.stop="handleRecharge(scope.row, 1)" size="small">充值</el-button>
                        <el-button type="danger" @click.stop="handleRecharge(scope.row, 2)" size="small">调减</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <div class="balance-summary">
                    筛选用户余额合计：
                    <span>{{ formatCurrency((summary.totalBalance || 0) / 100, 2, '.', ',') }}</span>
                </div>
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>
    <RecordDrawer ref="recordDrawer" />
    <el-dialog v-model="recharge.dialogVisible" :title="recharge.formValue.type == 1 ? '用户充值' : '用户余额调减'" width="400">
        <el-form ref="rechargeFormRef" :model="recharge.formValue" :rules="recharge.formRules" label-width="80px"
            status-icon>
            <el-form-item label="充值金额" prop="adjAmt">
                <el-input-number v-model="recharge.formValue.adjAmt"
                    :placeholder="recharge.formValue.type == 1 ? '请输入充值金额（元）' : '请输入调减金额（元）'" :min="0.01" :precision="2"
                    :controls="false" style="width: 100%" />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="recharge.dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="rechargeDialogConfirm">确认</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import RecordDrawer from "./components/RecordDrawer.vue"
import { getRechargeListFun, rechargeFun } from "@/api/recharge"
import { formatCurrency } from "@/util/formValidator";

const statusMap = {
    1: "微信小程序",
    2: "抖音小程序",
    3: "后台管理系统",
};
const recordDrawer = ref();
// 高级查询信息
const search = reactive({
    isZeroBalance: 'false',
    userName: "",
    phone: "",

})
// 通用信息
const state = reactive({
    fullLoading: false,
    tableLoading: false,
    options: [
        { label: "是", value: 'true' },
        { label: "否", value: 'false' },
    ],
    options2: [
        { label: "未充值用户", value: 0 },
        { label: "内部用户", value: 1 },
    ],});
// 充值表单信息
const recharge = reactive({
    dialogVisible: false,
    formValue: {
        adjAmt: null,
        id: null,
        type: 1,// 1充值 2调减
    },
    formRules: {
        adjAmt: [{ required: true, message: '请输入金额', trigger: 'blur' }],
    },
})

const tableData = ref([]);
const summary = reactive({
    totalBalance: 0,
});
const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});

// 查询 1查询 2重置
const searchFun = (type) => {
    if (type == 2) {
        search.userName = '';
        search.phone = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.tableLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }
    for (let key in search) {
        if (search[key]) {
            params.keys.push(key);
            params.formValue[key] = search[key];
        }
    }
    getRechargeListFun(params).then((res) => {
        tableData.value = res.data.records;
        pagination.total = res.data.total;
        summary.totalBalance = res.data.totalBalance || 0;
    }).finally(() => {
        state.tableLoading = false;
    });
}
const rowClick = (row, column, event) => {
    recordDrawer.value.showDrawer(row.id);
}
// 区分行状态
const tableRowClassName = ({ row }) => {
    if (row.type === '充值') {
        return 'success-row'
    } else if (row.type === '调减') {
        return 'warning-row'
    }
    return '';
}
// 编辑确认
const filterUserNature = (row) => {
    const userNature = row?.userNature;
    if (userNature === undefined || userNature === null || userNature === '') {
        return '';
    }
    const node = state.options2.find((item) => item.value == userNature);
    return node?.label || '--';
}
const rechargeFormRef = ref();
// 充值
const handleRecharge = (row, type) => {
    recharge.formValue.id = row.id;
    recharge.formValue.type = type;
    recharge.formValue.adjAmt = null;
    recharge.dialogVisible = true;
}
// 充值确认
const rechargeDialogConfirm = () => {
    // 1.校验表单
    rechargeFormRef.value.validate((valid) => {
        if (valid) {
            state.fullLoading = true;
            const params = {
                adjAmt: recharge.formValue.adjAmt * 100,
                userId: recharge.formValue.id,
            }
            rechargeFun(params, recharge.formValue.type).then((res) => {
                recharge.dialogVisible = false;
                intTableData();
                recordDrawer.value.state.userId = '';
            }).finally(() => {
                state.fullLoading = false;
            });
        }
    })
}
onMounted(() => {
    intTableData();
});
</script>
<style lang="scss" scoped>
.demo-ruleForm {
    margin-top: 15px;
}

.pagination-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
}

.balance-summary {
    color: #6b7280;
    font-size: 14px;
    white-space: nowrap;
}

.balance-summary span {
    color: #12877e;
    font-size: 16px;
    font-weight: 700;
}

.el-pagination {
    margin-top: 0;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
}

::v-deep .el-input-number .el-input__inner {
    text-align: left;
}

::v-deep.el-table .warning-row {
    --el-table-tr-bg-color: var(--el-color-warning-light-9);
}

::v-deep.el-table .success-row {
    --el-table-tr-bg-color: var(--el-color-success-light-9);
}

::v-deep.el-table .striped-row {
    --el-table-tr-bg-color: #fafafa;
}
</style>